import { PanelToolbar } from '../../components/panels/PanelToolbar';
import { LogTrackPanel } from '../../components/panels/LogTrackPanel';
import { ProcessingNotice } from '../../components/panels/ProcessingNotice';
import type { Track } from '../../components/panels/LogTrackPanel';
import {
  ACTUAL_TOPS,
  CHROMATOGRAPH,
  DEPTH,
  GAMMA_RAY,
  INT_LITHO,
  MD,
  POROSITY,
  RESISTIVITY,
  TG,
  TVDSS,
} from './tracks';

const NARROW = (title: string, width = 40): Track => ({ title, width, vertical: true });

/** RT Depth Log — still rendering, as it usually is when first opened. */
export function RtDepthLog() {
  return (
    <section className="panel panel--full" aria-label="RT Depth Log">
      <PanelToolbar title="RT DEPTH LOG" accent />
      <ProcessingNotice />
    </section>
  );
}

const COMPOSITE: Track[] = [
  DEPTH,
  { title: 'OPS REMARKS', width: 128 },
  NARROW('INCLINATION', 44),
  DEPTH,
  ACTUAL_TOPS,
  GAMMA_RAY,
  RESISTIVITY,
  POROSITY,
  TG,
  INT_LITHO,
  CHROMATOGRAPH,
  { title: 'WH & BH', width: 72 },
  { title: 'CH RATIO', width: 66 },
  NARROW('HAWORTH', 38),
  NARROW('OIL SHAKING', 38),
  { title: 'SUMMARY', width: 86 },
  NARROW('SW', 34),
  NARROW('% LITHO', 38),
  NARROW('NET PAY', 38),
];

export function CompositeLog() {
  return (
    <section className="panel panel--full" aria-label="Composite Log">
      <PanelToolbar title="RT COMPOSITE LOG" accent />
      <LogTrackPanel tracks={COMPOSITE} depths={[10, 20, 30, 40]} minHeight={260} />
    </section>
  );
}

const PRESSURE: Track[] = [
  MD,
  ACTUAL_TOPS,
  NARROW('PRETEST', 44),
  { title: 'INT. LITHO', width: 56 },
  GAMMA_RAY,
  RESISTIVITY,
  POROSITY,
  TG,
  CHROMATOGRAPH,
  NARROW('HAWORTH', 38),
  NARROW('PIXLER', 38),
  NARROW('OIL SHAKING', 38),
  NARROW('TVDSS', 38),
  {
    title: 'PORE PRESSURE',
    width: 420,
    scales: [
      { name: 'Pressure Point (psi)', min: '0    800    1600    2400    3200', max: '4000    4800    5600    6400' },
    ],
  },
];

export function PressureLog() {
  return (
    <section className="panel panel--full" aria-label="Pressure Log">
      <PanelToolbar title="Pressure Plot" options={['Pressure Plot', 'Pore Pressure']} />
      <LogTrackPanel tracks={PRESSURE} minHeight={260} />
    </section>
  );
}

const PORE: Track[] = [
  MD,
  TVDSS,
  ACTUAL_TOPS,
  { title: 'INT. LITHO', width: 56 },
  GAMMA_RAY,
  {
    title: 'PORE PRESSURE / FRACTURE GRADIENT',
    width: 460,
    scales: [
      { name: 'Pore Pressure (Low / Mid / High Case)', min: '8', unit: 'ppg', max: '20' },
      { name: 'Overburden Gradient', min: '8', unit: 'ppg', max: '20' },
      { name: 'Fracture Gradient (Low / Mid / High Case)', min: '8', unit: 'ppg', max: '20' },
    ],
  },
  { title: 'MUD WEIGHT', width: 120, scales: [{ min: '8', unit: 'ppg', max: '20' }] },
];

export function RtPorePressure() {
  return (
    <section className="panel panel--full" aria-label="RT Pore Pressure">
      <PanelToolbar title="RT PORE PRESSURE" accent />
      <LogTrackPanel tracks={PORE} minHeight={260} />
    </section>
  );
}
